import styled from 'styled-components';
import { theme, palette } from 'styled-tools';
import { BsPlus } from 'react-icons/bs';

const S = {};

S.AddIcon = styled(BsPlus)`
  width: 24px;
  height: 24px;
`;

S.AddButton = styled.button`
  align-self: flex-start;
  display: flex;
  align-items: center;
  font-size: ${theme('fontSize.sm')};
  color: ${palette('colorAddButton')};
  border: 0;
  padding: ${theme('spacing.xxs')};
  background-color: transparent;
  transition: ${theme('transition')};
  outline: none;
  cursor: pointer;
  &:hover {
    color: ${palette('colorAddButtonHover')};
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    &:hover {
      color: ${palette('colorAddButton')};
    }
  }

  ${theme('components.AddButton')}
`;

export default S;
